export default __webpack_public_path__ + "static/media/android-chrome-192x192.0d620e6a.png";